import React from 'react';

const PrivacyPage = () => {
  return (
    <div className="py-20 bg-white">
      <div className="container mx-auto px-6 max-w-4xl">
        <h1 className="text-3xl md:text-4xl font-bold text-[#007dc6] mb-8">Política de Privacidad</h1>
        
        <div className="prose prose-lg text-gray-600">
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">1. Información que Recopilamos</h2>
            <p>
              Recopilamos información personal que usted nos proporciona voluntariamente al registrarse, como nombre, dirección de correo electrónico, 
              información de contacto y datos de pago cuando sea necesario para la prestación de nuestros servicios.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">2. Uso de la Información</h2>
            <p>
              Utilizamos su información personal para: proporcionar y mejorar nuestros servicios, procesar transacciones, comunicarnos con usted, 
              y cumplir con obligaciones legales. No vendemos ni compartimos su información con terceros sin su consentimiento.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">3. Protección de Datos</h2>
            <p>
              Implementamos medidas de seguridad técnicas y organizativas para proteger sus datos personales contra accesos no autorizados, 
              alteración, divulgación o destrucción.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">4. Derechos del Usuario</h2>
            <p>
              Usted tiene derecho a acceder, corregir, eliminar o limitar el uso de sus datos personales. Puede ejercer estos derechos 
              contactándonos a través de los medios proporcionados en nuestro sitio web.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-gray-800 mb-4">5. Cambios en la Política</h2>
            <p>
              Esta política puede ser actualizada periódicamente. Le notificaremos sobre cambios significativos mediante un aviso visible 
              en nuestro sitio web o por correo electrónico.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;